// update state
export const setSelectedContextItemsAction = (payload) => {
    return {
        type: "CONTEXTSELECTION",
        payload
    }
}

export const setSelectedContextId = (payload) => {
    return {
        type: "CONTEXTIDSELECTION",
        payload
    }
}


// WEBPACK FOOTER //
// ./src/actions/setSelectedContextItemsAction.js